import * as J from "react";
import { a as E, T as Q, i as Y, b as Z, E as ee, x, r as te, c as se } from "../createReactComponent-58f9bea8.mjs";
import { n as h } from "../property-9daa16cd.mjs";
import { r as I } from "../state-7560d4dc.mjs";
import { e as H } from "../query-d94c86d2.mjs";
import { r as ie } from "../query-async-a940115b.mjs";
import { a as W, i as K, t as oe, e as D } from "../class-map-2994e95e.mjs";
import { o as S } from "../if-defined-47693dfa.mjs";
import { m as G, p as ne, v as $, r as w, M as O } from "../live-6c85dd15.mjs";
import { d as re, o as ae, e as le, c as he, s as L } from "../tooltip-cb602d1f.mjs";
import { f as y, b as ce, a as ue } from "../menu-item-group-76fb1396.mjs";
import { r as pe } from "../icon-c572aa57.mjs";
import { r as de } from "../loader-d420db9a.mjs";
import { r as me } from "../menu-3df3d7c3.mjs";
import { r as be } from "../button-7600b6ca.mjs";
import { r as ve } from "../pill-a1831740.mjs";
import { r as xe } from "../pill-group-834f5519.mjs";
import "../base-e16d29d8.mjs";
import "../purify.es-39f8036b.mjs";
import "../slot-controller-fa97ce97.mjs";
import "../icon-button-a9d2a2d1.mjs";
import "../menu-item-65dd9fa4.mjs";
import "../checkbox-46b40c6a.mjs";
import "../radio-8b0e9514.mjs";
import "../utils-cf5bbdd1.mjs";
import "../style-map-c3339321.mjs";
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const A = window, k = A.ShadowRoot && (A.ShadyCSS === void 0 || A.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, X = Symbol(), j = /* @__PURE__ */ new WeakMap();
let ye = class {
  constructor(s, e, t) {
    if (this._$cssResult$ = !0, t !== X)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = s, this.t = e;
  }
  get styleSheet() {
    let s = this.o;
    const e = this.t;
    if (k && s === void 0) {
      const t = e !== void 0 && e.length === 1;
      t && (s = j.get(e)), s === void 0 && ((this.o = s = new CSSStyleSheet()).replaceSync(this.cssText), t && j.set(e, s));
    }
    return s;
  }
  toString() {
    return this.cssText;
  }
};
const ge = (s, e) => {
  k ? s.adoptedStyleSheets = e.map((t) => t instanceof CSSStyleSheet ? t : t.styleSheet) : e.forEach((t) => {
    const i = document.createElement("style"), o = A.litNonce;
    o !== void 0 && i.setAttribute("nonce", o), i.textContent = t.cssText, s.appendChild(i);
  });
}, q = k ? (s) => s : (s) => s instanceof CSSStyleSheet ? ((e) => {
  let t = "";
  for (const i of e.cssRules)
    t += i.cssText;
  return ((i) => new ye(typeof i == "string" ? i : i + "", void 0, X))(t);
})(s) : s;
var P;
const _ = window, N = _.trustedTypes, fe = N ? N.emptyScript : "", B = _.reactiveElementPolyfillSupport, U = { toAttribute(s, e) {
  switch (e) {
    case Boolean:
      s = s ? fe : null;
      break;
    case Object:
    case Array:
      s = s == null ? s : JSON.stringify(s);
  }
  return s;
}, fromAttribute(s, e) {
  let t = s;
  switch (e) {
    case Boolean:
      t = s !== null;
      break;
    case Number:
      t = s === null ? null : Number(s);
      break;
    case Object:
    case Array:
      try {
        t = JSON.parse(s);
      } catch {
        t = null;
      }
  }
  return t;
} }, R = (s, e) => e !== s && (e == e || s == s), T = { attribute: !0, type: String, converter: U, reflect: !1, hasChanged: R }, V = "finalized";
let C = class extends HTMLElement {
  constructor() {
    super(), this._$Ei = /* @__PURE__ */ new Map(), this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
  }
  static addInitializer(s) {
    var e;
    this.finalize(), ((e = this.h) !== null && e !== void 0 ? e : this.h = []).push(s);
  }
  static get observedAttributes() {
    this.finalize();
    const s = [];
    return this.elementProperties.forEach((e, t) => {
      const i = this._$Ep(t, e);
      i !== void 0 && (this._$Ev.set(i, t), s.push(i));
    }), s;
  }
  static createProperty(s, e = T) {
    if (e.state && (e.attribute = !1), this.finalize(), this.elementProperties.set(s, e), !e.noAccessor && !this.prototype.hasOwnProperty(s)) {
      const t = typeof s == "symbol" ? Symbol() : "__" + s, i = this.getPropertyDescriptor(s, t, e);
      i !== void 0 && Object.defineProperty(this.prototype, s, i);
    }
  }
  static getPropertyDescriptor(s, e, t) {
    return { get() {
      return this[e];
    }, set(i) {
      const o = this[s];
      this[e] = i, this.requestUpdate(s, o, t);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(s) {
    return this.elementProperties.get(s) || T;
  }
  static finalize() {
    if (this.hasOwnProperty(V))
      return !1;
    this[V] = !0;
    const s = Object.getPrototypeOf(this);
    if (s.finalize(), s.h !== void 0 && (this.h = [...s.h]), this.elementProperties = new Map(s.elementProperties), this._$Ev = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
      const e = this.properties, t = [...Object.getOwnPropertyNames(e), ...Object.getOwnPropertySymbols(e)];
      for (const i of t)
        this.createProperty(i, e[i]);
    }
    return this.elementStyles = this.finalizeStyles(this.styles), !0;
  }
  static finalizeStyles(s) {
    const e = [];
    if (Array.isArray(s)) {
      const t = new Set(s.flat(1 / 0).reverse());
      for (const i of t)
        e.unshift(q(i));
    } else
      s !== void 0 && e.push(q(s));
    return e;
  }
  static _$Ep(s, e) {
    const t = e.attribute;
    return t === !1 ? void 0 : typeof t == "string" ? t : typeof s == "string" ? s.toLowerCase() : void 0;
  }
  _$Eu() {
    var s;
    this._$E_ = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$Eg(), this.requestUpdate(), (s = this.constructor.h) === null || s === void 0 || s.forEach((e) => e(this));
  }
  addController(s) {
    var e, t;
    ((e = this._$ES) !== null && e !== void 0 ? e : this._$ES = []).push(s), this.renderRoot !== void 0 && this.isConnected && ((t = s.hostConnected) === null || t === void 0 || t.call(s));
  }
  removeController(s) {
    var e;
    (e = this._$ES) === null || e === void 0 || e.splice(this._$ES.indexOf(s) >>> 0, 1);
  }
  _$Eg() {
    this.constructor.elementProperties.forEach((s, e) => {
      this.hasOwnProperty(e) && (this._$Ei.set(e, this[e]), delete this[e]);
    });
  }
  createRenderRoot() {
    var s;
    const e = (s = this.shadowRoot) !== null && s !== void 0 ? s : this.attachShadow(this.constructor.shadowRootOptions);
    return ge(e, this.constructor.elementStyles), e;
  }
  connectedCallback() {
    var s;
    this.renderRoot === void 0 && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (s = this._$ES) === null || s === void 0 || s.forEach((e) => {
      var t;
      return (t = e.hostConnected) === null || t === void 0 ? void 0 : t.call(e);
    });
  }
  enableUpdating(s) {
  }
  disconnectedCallback() {
    var s;
    (s = this._$ES) === null || s === void 0 || s.forEach((e) => {
      var t;
      return (t = e.hostDisconnected) === null || t === void 0 ? void 0 : t.call(e);
    });
  }
  attributeChangedCallback(s, e, t) {
    this._$AK(s, t);
  }
  _$EO(s, e, t = T) {
    var i;
    const o = this.constructor._$Ep(s, t);
    if (o !== void 0 && t.reflect === !0) {
      const n = (((i = t.converter) === null || i === void 0 ? void 0 : i.toAttribute) !== void 0 ? t.converter : U).toAttribute(e, t.type);
      this._$El = s, n == null ? this.removeAttribute(o) : this.setAttribute(o, n), this._$El = null;
    }
  }
  _$AK(s, e) {
    var t;
    const i = this.constructor, o = i._$Ev.get(s);
    if (o !== void 0 && this._$El !== o) {
      const n = i.getPropertyOptions(o), a = typeof n.converter == "function" ? { fromAttribute: n.converter } : ((t = n.converter) === null || t === void 0 ? void 0 : t.fromAttribute) !== void 0 ? n.converter : U;
      this._$El = o, this[o] = a.fromAttribute(e, n.type), this._$El = null;
    }
  }
  requestUpdate(s, e, t) {
    let i = !0;
    s !== void 0 && (((t = t || this.constructor.getPropertyOptions(s)).hasChanged || R)(this[s], e) ? (this._$AL.has(s) || this._$AL.set(s, e), t.reflect === !0 && this._$El !== s && (this._$EC === void 0 && (this._$EC = /* @__PURE__ */ new Map()), this._$EC.set(s, t))) : i = !1), !this.isUpdatePending && i && (this._$E_ = this._$Ej());
  }
  async _$Ej() {
    this.isUpdatePending = !0;
    try {
      await this._$E_;
    } catch (e) {
      Promise.reject(e);
    }
    const s = this.scheduleUpdate();
    return s != null && await s, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var s;
    if (!this.isUpdatePending)
      return;
    this.hasUpdated, this._$Ei && (this._$Ei.forEach((i, o) => this[o] = i), this._$Ei = void 0);
    let e = !1;
    const t = this._$AL;
    try {
      e = this.shouldUpdate(t), e ? (this.willUpdate(t), (s = this._$ES) === null || s === void 0 || s.forEach((i) => {
        var o;
        return (o = i.hostUpdate) === null || o === void 0 ? void 0 : o.call(i);
      }), this.update(t)) : this._$Ek();
    } catch (i) {
      throw e = !1, this._$Ek(), i;
    }
    e && this._$AE(t);
  }
  willUpdate(s) {
  }
  _$AE(s) {
    var e;
    (e = this._$ES) === null || e === void 0 || e.forEach((t) => {
      var i;
      return (i = t.hostUpdated) === null || i === void 0 ? void 0 : i.call(t);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(s)), this.updated(s);
  }
  _$Ek() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$E_;
  }
  shouldUpdate(s) {
    return !0;
  }
  update(s) {
    this._$EC !== void 0 && (this._$EC.forEach((e, t) => this._$EO(t, this[t], e)), this._$EC = void 0), this._$Ek();
  }
  updated(s) {
  }
  firstUpdated(s) {
  }
};
C[V] = !0, C.elementProperties = /* @__PURE__ */ new Map(), C.elementStyles = [], C.shadowRootOptions = { mode: "open" }, B == null || B({ ReactiveElement: C }), ((P = _.reactiveElementVersions) !== null && P !== void 0 ? P : _.reactiveElementVersions = []).push("1.6.3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const $e = Symbol();
class Ie {
  get taskComplete() {
    return this.t || (this.i === 1 ? this.t = new Promise((e, t) => {
      this.o = e, this.h = t;
    }) : this.i === 3 ? this.t = Promise.reject(this.l) : this.t = Promise.resolve(this.u)), this.t;
  }
  constructor(e, t, i) {
    var n;
    this.p = 0, this.i = 0, (this._ = e).addController(this);
    const o = typeof t == "object" ? t : { task: t, args: i };
    this.v = o.task, this.j = o.args, this.m = o.argsEqual ?? Ee, this.k = o.onComplete, this.A = o.onError, this.autoRun = o.autoRun ?? !0, "initialValue" in o && (this.u = o.initialValue, this.i = 2, this.O = (n = this.T) == null ? void 0 : n.call(this));
  }
  hostUpdate() {
    this.autoRun === !0 && this.S();
  }
  hostUpdated() {
    this.autoRun === "afterUpdate" && this.S();
  }
  T() {
    if (this.j === void 0)
      return;
    const e = this.j();
    if (!Array.isArray(e))
      throw Error("The args function must return an array");
    return e;
  }
  async S() {
    const e = this.T(), t = this.O;
    this.O = e, e === t || e === void 0 || t !== void 0 && this.m(t, e) || await this.run(e);
  }
  async run(e) {
    var a, c, u, b, f;
    let t, i;
    e ?? (e = this.T()), this.O = e, this.i === 1 ? (a = this.q) == null || a.abort() : (this.t = void 0, this.o = void 0, this.h = void 0), this.i = 1, this.autoRun === "afterUpdate" ? queueMicrotask(() => this._.requestUpdate()) : this._.requestUpdate();
    const o = ++this.p;
    this.q = new AbortController();
    let n = !1;
    try {
      t = await this.v(e, { signal: this.q.signal });
    } catch (p) {
      n = !0, i = p;
    }
    if (this.p === o) {
      if (t === $e)
        this.i = 0;
      else {
        if (n === !1) {
          try {
            (c = this.k) == null || c.call(this, t);
          } catch {
          }
          this.i = 2, (u = this.o) == null || u.call(this, t);
        } else {
          try {
            (b = this.A) == null || b.call(this, i);
          } catch {
          }
          this.i = 3, (f = this.h) == null || f.call(this, i);
        }
        this.u = t, this.l = i;
      }
      this._.requestUpdate();
    }
  }
  abort(e) {
    var t;
    this.i === 1 && ((t = this.q) == null || t.abort(e));
  }
  get value() {
    return this.u;
  }
  get error() {
    return this.l;
  }
  get status() {
    return this.i;
  }
  render(e) {
    var t, i, o, n;
    switch (this.i) {
      case 0:
        return (t = e.initial) == null ? void 0 : t.call(e);
      case 1:
        return (i = e.pending) == null ? void 0 : i.call(e);
      case 2:
        return (o = e.complete) == null ? void 0 : o.call(e, this.value);
      case 3:
        return (n = e.error) == null ? void 0 : n.call(e, this.error);
      default:
        throw Error("Unexpected status: " + this.i);
    }
  }
}
const Ee = (s, e) => s === e || s.length === e.length && s.every((t, i) => !R(t, e[i])), Se = W(class extends K {
  constructor() {
    super(...arguments), this.key = E;
  }
  render(s, e) {
    return this.key = s, e;
  }
  update(s, [e, t]) {
    return e !== this.key && (G(s), this.key = e), t;
  }
}), F = (s, e, t) => {
  const i = /* @__PURE__ */ new Map();
  for (let o = e; o <= t; o++)
    i.set(s[o], o);
  return i;
}, we = W(class extends K {
  constructor(s) {
    if (super(s), s.type !== oe.CHILD)
      throw Error("repeat() can only be used in text expressions");
  }
  dt(s, e, t) {
    let i;
    t === void 0 ? t = e : e !== void 0 && (i = e);
    const o = [], n = [];
    let a = 0;
    for (const c of s)
      o[a] = i ? i(c, a) : a, n[a] = t(c, a), a++;
    return { values: n, keys: o };
  }
  render(s, e, t) {
    return this.dt(s, e, t).values;
  }
  update(s, [e, t, i]) {
    const o = ne(s), { values: n, keys: a } = this.dt(e, t, i);
    if (!Array.isArray(o))
      return this.ut = a, n;
    const c = this.ut ?? (this.ut = []), u = [];
    let b, f, p = 0, m = o.length - 1, d = 0, v = n.length - 1;
    for (; p <= m && d <= v; )
      if (o[p] === null)
        p++;
      else if (o[m] === null)
        m--;
      else if (c[p] === a[d])
        u[d] = $(o[p], n[d]), p++, d++;
      else if (c[m] === a[v])
        u[v] = $(o[m], n[v]), m--, v--;
      else if (c[p] === a[v])
        u[v] = $(o[p], n[v]), w(s, u[v + 1], o[p]), p++, v--;
      else if (c[m] === a[d])
        u[d] = $(o[m], n[d]), w(s, o[p], o[m]), m--, d++;
      else if (b === void 0 && (b = F(a, d, v), f = F(c, p, m)), b.has(c[p]))
        if (b.has(c[m])) {
          const g = f.get(a[d]), M = g !== void 0 ? o[g] : null;
          if (M === null) {
            const z = w(s, o[p]);
            $(z, n[d]), u[d] = z;
          } else
            u[d] = $(M, n[d]), w(s, o[p], M), o[g] = null;
          d++;
        } else
          O(o[m]), m--;
      else
        O(o[p]), p++;
    for (; d <= v; ) {
      const g = w(s, u[v + 1]);
      $(g, n[d]), u[d++] = g;
    }
    for (; p <= m; ) {
      const g = o[p++];
      g !== null && O(g);
    }
    return this.ut = a, G(s, u), Q;
  }
});
var Ce = Object.defineProperty, Ae = Object.getOwnPropertyDescriptor, l = (s, e, t, i) => {
  for (var o, n = i > 1 ? void 0 : i ? Ae(e, t) : e, a = s.length - 1; a >= 0; a--)
    (o = s[a]) && (n = (i ? o(e, t, n) : o(n)) || n);
  return i && n && Ce(e, t, n), n;
}, _e = ((s) => (s.DEFAULT = "default", s.LARGE = "large", s.STANDARD = "standard", s.MEDIUM = "medium", s.SMALL = "small", s))(_e || {}), Me = ((s) => (s.INPUT = "input", s.STANDARD = "standard", s))(Me || {}), Oe = ((s) => (s.SINGLE = "single", s.MULTI = "multi", s.DEFAULT = "default", s))(Oe || {}), Pe = ((s) => (s.MEDIUM = "medium", s.LARGE = "large", s))(Pe || {});
function Te(s) {
  s.preventDefault();
}
const Ue = (s) => `ex-menu-item~${s.index}`;
class r extends ee {
  constructor() {
    super(...arguments), this.label = "", this.helpText = "", this.infoText = "", this.errorMsg = "", this.noResultText = "Please select valid option", this.noOptionText = "No more options available", this.disabled = !1, this.readonly = !1, this.required = !1, this.optional = !1, this.searchIcon = !1, this.invalid = !1, this.value = "", this.size = "default", this.type = "input", this.select = "default", this.searchSize = "medium", this.tooltipText = "", this.menuHeight = "default", this.footerType = "info", this.comboboxOptions = [], this.defaultValues = [], this.hideClearIcon = !1, this.options = [], this.inputValue = "", this.isOpen = !1, this.supressMenuWidth = 0, this.activeIndex = -1, this.unselectedItemsLength = 4, this.selectedItems = [], this.strategy = "absolute", this.showStatusIcon = !1, this.selectAllMenuItem = !1, this.autoComplete = "on", this.showClear = !1, this.searchIconLabel = "", this.statusIconLabel = "", this.selectedValues = [], this.menuItems = [], this.adjustHeight = !0, this.comboboxAsyncDataTask = new Ie(this, { task: async ([e]) => {
      this.setComboboxData(e, []), this.inputElement && this.inputValue && this.onInputFocusHandler();
    }, args: () => [this.comboboxOptions] }), this.getMenuItem = ({ label: e, index: t, selected: i, category: o, secondaryText: n }) => {
      const a = this.select === "default" && i, c = a ? "menu-item" : "combobox-menu-item";
      return x`<ex-menu-item
      data-index=${t}
      @onItemSelect=${(u) => this.onItemSelectHandler(u)}
      highlightText=${this.inputValue}
      exportparts=${c}
      data-selected=${a}
      secondary-text=${n}
      category=${o}
      ?selected=${i}
      variant=${this.select === "multi" ? "checkbox" : "option"}
      ?category-without-arrow=${!!o}
      >${e}</ex-menu-item
    >`;
    }, this.hide = () => {
      var e;
      (e = this.inputElement) == null || e.removeAttribute("hasTypeahead"), this.isOpen = !1;
    };
  }
  updateSelectedValueFromInput() {
    if (this.select === "single" && this.inputValue) {
      const e = this.options.find((t) => t.label === this.inputValue || t.value === this.inputValue);
      e && (this.value = e.value, this.options = this.options.map((t) => ({ ...t, selected: t.value === e.value })), this.selectedItems = [e]);
    }
  }
  updated(e) {
    super.updated(e), e.has("inputValue") && this.updateSelectedValueFromInput();
  }
  getMenuItems() {
    return x`${we(this.options, Ue, this.getMenuItem)}`;
  }
  setMenuHeader() {
    if (this.select === "multi" && this.selectedItems.length > 0)
      return "showHeader";
  }
  getMenuItemGroup() {
    var i;
    const e = this.options.length === ((i = this.selectedItems) == null ? void 0 : i.length), t = this.selectedItems.length > 0 && this.selectedItems.length !== this.options.length;
    return x`<ex-menu-item-group
      showHeader=${S(this.setMenuHeader())}
      noresultstext=${e ? this.noOptionText : this.noResultText}
      highlightText=${this.inputValue}
      ?forceNoOptionText=${e && this.select === "default"}
      exportparts="category-heading, combobox-menu-item"
    >
      ${this.selectAllMenuItem && this.select === "multi" ? x` <ex-menu-item
            variant="checkbox"
            ?selected=${e}
            ?indeterminate=${t}
            @onItemSelect=${() => this.onAllItemSelectHandler()}
            >All</ex-menu-item
          >` : E}
      ${this.getMenuItems()}
      ${this.select === "multi" ? x`
            <ex-pill-group
              slot="header"
              .values=${this.selectedItems}
              @onClear=${this.clearAllSelections}
              @onRemove=${this.removePill}
              ?showClear=${this.showClear}
              interactive
              removable
            >
            </ex-pill-group>
          ` : E}
    </ex-menu-item-group>`;
  }
  getMenu() {
    var t;
    const e = this.inputValue || ((t = this.selectedItems) == null ? void 0 : t.length);
    return x`<ex-menu
      height="${this.menuHeight}"
      variant="action"
      exportparts="menu"
      width="fluid"
      class=${D({ combobox__menu: !0, "combobox__menu--active": this.isOpen === !0, "combobox__menu--fixed": this.strategy === "fixed" })}
      @mousedown=${this.select === "multi" ? Te : void 0}
    >
      ${Se(e, this.getMenuItemGroup())}
    </ex-menu>`;
  }
  getMainMenu() {
    return x`<div
      slot="typeaheadmenu"
      class="${!this.options.length && "typeaheadmenu-hidden"}"
    >
      ${this.getMenu()}
    </div>`;
  }
  getFilteredItem() {
    return this.options.filter((e) => e.selected).map(({ label: e, value: t, category: i }) => ({ value: t, label: e, category: i })) || [];
  }
  dispatchOnChangeEvent() {
    this.select === "single" ? this.dispatchCustomEvent("on-change", { data: this.getFilteredItem()[0] || {} }) : this.dispatchCustomEvent("on-change", { data: this.getFilteredItem() });
  }
  dispatchOnRemoveEvent(e) {
    const t = new CustomEvent("remove", { bubbles: !0, cancelable: !1, composed: !0, detail: { value: e } });
    this.dispatchEvent(t);
  }
  dispatchOnClearEvent() {
    const e = new CustomEvent("clear", { bubbles: !0, cancelable: !1, composed: !0 });
    this.dispatchEvent(e);
  }
  onItemSelectHandler(e) {
    var i, o;
    const t = ((o = (i = e.target) == null ? void 0 : i.dataset) == null ? void 0 : o.index) ?? "-1";
    this.selectItemWithIndex(parseInt(t, 10)), this.selectItem(this.activeIndex);
  }
  onAllItemSelectHandler() {
    var e;
    this.selectedItems.length !== this.options.length ? (this.options.forEach((t) => {
      t.selected = !0;
    }), this.selectedItems = [...this.options], (e = this.inputElement) == null || e.setAttribute("value", `${this.selectedItems[0].label} (+${this.selectedItems.length - 1})`)) : (this.options.forEach((t) => {
      t.selected = !1;
    }), this.selectedItems = [], this.clearInputValue()), this.dispatchOnChangeEvent();
  }
  clearInputValue() {
    var e;
    this.inputValue = "", this.value = this.inputValue, (e = this.inputElement) == null || e.setAttribute("value", "");
  }
  showSelectedInputValueOrPills(e) {
    var o, n;
    const t = this.selectedItems.length, i = this.options[e].label;
    this.select === "single" || t === 0 ? (o = this.inputElement) == null || o.setAttribute("value", i) : (n = this.inputElement) == null || n.setAttribute("value", `${i} (+${t})`);
  }
  clearPreviousSelectionForSingleSelect(e) {
    this.select === "single" && (this.options = [...this.options.map((t) => ({ ...t, selected: !1 }))], e && this.selectedItems.pop(this.options[parseInt(e, 10)]));
  }
  clearAllSelections() {
    this.options = this.options.map((e) => ({ ...e, selected: !1 })), this.selectedItems = [], this.clearInputValue(), this.dispatchOnClearEvent();
  }
  dispatchCustomEvent(e, t) {
    this.dispatchEvent(new CustomEvent(e, { detail: t, bubbles: !0, composed: !0 }));
  }
  selectItemWithIndex(e) {
    if (this.options[e].selected) {
      const t = new CustomEvent("removePill", { detail: { value: { index: e } } });
      return this.removePill(t);
    }
    return e >= 0 && (this.clearPreviousSelectionForSingleSelect(e), this.options[e].selected = !0), this.showSelectedInputValueOrPills(e), this.dispatchOnChangeEvent(), this.selectedItems = [...this.selectedItems, this.options[e]], this.select === "single" && (this.value = this.inputValue), E;
  }
  removePill(e) {
    var i, o;
    const { detail: t } = e;
    if (t && t.value && t.value.index !== void 0) {
      const { index: n } = t.value;
      if (n >= 0 && n < this.options.length)
        if (this.options[n].selected = !1, this.selectedItems = this.selectedItems.filter((a) => a.index !== n), this.selectedItems.length === 0)
          this.clearInputValue();
        else if (this.selectedItems.length === 1)
          (i = this.inputElement) == null || i.setAttribute("value", `${this.selectedItems[0].label}`);
        else {
          const a = this.selectedItems.length - 1;
          (o = this.inputElement) == null || o.setAttribute("value", `${this.selectedItems[a].label} (+${a})`);
        }
      this.dispatchOnRemoveEvent(this.options[n].label);
    }
  }
  onInputHandler(e) {
    var t;
    this.inputValue = (t = e.target) == null ? void 0 : t.value, this.dispatchCustomEvent("on-input", { data: this.inputValue }), this.onOptionChange(-1), this.value = this.inputValue;
  }
  async onInputFocusHandler() {
    var e, t;
    await new Promise((i) => setTimeout(i, 200)), (e = this.inputElement) == null || e.setAttribute("hasTypeahead", ""), this.isOpen = !0, (t = this.inputElement) != null && t.hasAttribute("hasTypeahead") && this.options.length === 0 && this.inputElement.removeAttribute("hasTypeahead");
  }
  async onInputBlurHandler() {
    await new Promise((e) => setTimeout(e, 200)), this.hide();
  }
  setComboboxData(e, t) {
    this.selectedValues = t, this.options = e.map(({ value: i, label: o, category: n, secondaryText: a }, c) => ({ index: c, value: i, label: o, selected: t.includes(i), category: n, secondaryText: a }));
  }
  dispatchSelectionChange() {
    this.dispatchCustomEvent("on-selection-change", { selectedValues: this.selectedValues });
  }
  firstUpdated() {
    this.initializeDefaultSelection();
  }
  async initializeDefaultSelection() {
    const e = this.extractSelectedValues();
    this.select === "single" ? this.applySingleSelection(e) : this.select === "default" ? this.applyDefaultSelection(e) : this.select === "multi" && this.applyMultiSelection();
  }
  extractSelectedValues() {
    return this.defaultValues && this.defaultValues.length > 0 ? this.select === "single" ? [this.defaultValues[0].label] : this.defaultValues.map(({ value: e }) => e) : [];
  }
  applySingleSelection(e) {
    var t, i;
    e.length > 0 && ((t = this.options) == null || t.forEach((o) => {
      o.selected = e.includes(o.label);
    }), (i = this.inputElement) == null || i.setAttribute("value", e[0]));
  }
  applyDefaultSelection(e) {
    var t;
    (t = this.options) == null || t.forEach((i, o) => {
      e.includes(i.value) && this.selectItemWithIndex(o);
    });
  }
  applyMultiSelection() {
    var e, t;
    this.options = this.comboboxOptions.map((i, o) => ({ ...i, index: o, selected: this.defaultValues.some((n) => n.value === i.value) })), this.selectedItems = this.options.filter((i) => i.selected), this.selectedItems.length > 1 ? (e = this.inputElement) == null || e.setAttribute("value", `${this.selectedItems[0].label} (+${this.selectedItems.length - 1})`) : this.selectedItems.length === 1 && ((t = this.inputElement) == null || t.setAttribute("value", this.selectedItems[0].label));
  }
  getActionFromKey(e) {
    const { key: t } = e;
    if (this.isOpen) {
      if (t === "ArrowDown")
        return y.NEXT;
      if (t === "ArrowUp")
        return y.PREVIOUS;
      if (t === "Escape")
        return y.CLOSE;
      if (t === "Enter" || t === " " || t === "Tab")
        return y.SELECT;
    }
    return y.UNKNOWN;
  }
  async handleKeyDown(e) {
    const t = this.getActionFromKey(e);
    if (t === y.CLOSE && this.clearInputValue(), this.selectMenuItems = [...await this.getAllMenuItems()], this.selectMenuItems.length > 0)
      if (t === y.NEXT || t === y.PREVIOUS) {
        const i = this.getUpdatedIndex(t);
        this.onOptionChange(i);
      } else
        t === y.SELECT && this.selectItem(this.activeIndex);
  }
  async onOptionChange(e) {
    var i;
    var t;
    !this.selectMenuItems || e < 0 || e >= this.selectMenuItems.length || (this.activeIndex = e, (i = this.selectMenuItems) == null || i.forEach((o) => {
      o.removeAttribute("focused");
    }), e > -1 && this.selectMenuItems.length > 0 && (this.selectMenuItems[e].setAttribute("focused", ""), (t = await this.comboboxMenu) && t.clientHeight < t.scrollHeight && function(o, n) {
      const { offsetHeight: a, offsetTop: c } = o, { offsetHeight: u, scrollTop: b } = n, f = c + a > b + u;
      c - a < b ? n.scrollTo(0, c + a - u) : f && n.scrollTo(0, c - u + a);
    }(this.selectMenuItems[e], await this.comboboxMenu), function(o) {
      const n = o.getBoundingClientRect();
      return n.top >= 0 && n.left >= 0 && n.bottom <= (window.innerHeight || document.documentElement.clientHeight) && n.right <= (window.innerWidth || document.documentElement.clientWidth);
    }(this.selectMenuItems[e]) || this.selectMenuItems[e].scrollIntoView({ behavior: "smooth", block: "nearest" })));
  }
  async connectedCallback() {
    super.connectedCallback(), await this.updateComplete, this.start();
  }
  disconnectedCallback() {
    this.stop();
  }
  async start() {
    this.selectControl && (this.cleanup = re(this.selectControl, await this.comboboxMenu, () => {
      this.reposition();
    }));
  }
  async stop() {
    return new Promise((e) => {
      this.cleanup ? (this.cleanup(), this.cleanup = void 0, requestAnimationFrame(() => e())) : e();
    });
  }
  findPlacementPosition(e) {
    var a, c, u, b;
    const t = document == null ? void 0 : document.querySelector("ex-combobox"), i = (a = t == null ? void 0 : t.shadowRoot) == null ? void 0 : a.querySelector("ex-input"), o = (c = i == null ? void 0 : i.getAttribute("label")) == null ? void 0 : c.length;
    let n = { mainAxis: -14, crossAxis: 0 };
    return o && e !== "bottom" ? n = { mainAxis: -40, crossAxis: 0 } : e === "bottom" && (n = { mainAxis: 16 - ((b = (u = i == null ? void 0 : i.shadowRoot) == null ? void 0 : u.querySelector("#help-text")) == null ? void 0 : b.offsetHeight), crossAxis: 0 }), n;
  }
  async reposition() {
    if (!this.selectControl)
      return;
    const e = [ae(({ placement: t }) => this.strategy === "fixed" ? t === "top" ? { mainAxis: -40, crossAxis: 0 } : this.helpText ? { mainAxis: -22, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0 } : this.findPlacementPosition(t)), le({ allowedPlacements: this.strategy === "fixed" ? ["bottom"] : ["top", "bottom"] })];
    e.push(L({ apply: async ({ rects: t }) => {
      var i;
      (i = (await this.comboboxMenu).style) == null || i.setProperty("width", `${t.reference.width + this.supressMenuWidth}px`);
    } })), this.adjustHeight && e.push(L({ apply: ({ availableHeight: t, availableWidth: i }) => {
      var o, n;
      this.adjustHeight = !1, (o = this.style) == null || o.setProperty("--auto-size-available-height", t - 18 + "px"), (n = this.style) == null || n.setProperty("--auto-size-available-width", `${i}px`);
    } })), he(this.selectControl, await this.comboboxMenu, { placement: "bottom", middleware: e, strategy: this.strategy }).then(async ({ x: t, y: i }) => {
      this.comboboxMenu && (await this.comboboxMenu).style && Object.assign((await this.comboboxMenu).style, { left: `${t}px`, top: `${i}px` });
    });
  }
  async getAllMenuItems() {
    var t, i, o;
    const e = ((o = (i = (t = await this.comboboxMenu) == null ? void 0 : t.querySelector("ex-menu-item-group")) == null ? void 0 : i.shadowRoot) == null ? void 0 : o.querySelectorAll("ex-menu-item:not([hidden])")) || [];
    return Array.from(e);
  }
  selectItem(e) {
    var o, n;
    if (e < 0)
      return;
    this.activeIndex = e;
    const t = ((n = (o = this.selectMenuItems[e]) == null ? void 0 : o.dataset) == null ? void 0 : n.index) ?? "-1";
    this.selectItemWithIndex(parseInt(t, 10));
    const i = this.options[e];
    i.selected = !i.selected, i.selected ? this.selectedValues = [...this.selectedValues, i.value] : this.selectedValues = this.selectedValues.filter((a) => a !== i.value), this.dispatchSelectionChange();
  }
  handleDrodownClick() {
    this.inputElement.focus(), this.isOpen ? this.onInputBlurHandler() : this.onInputFocusHandler();
  }
  getSuffix() {
    return this.type === "standard" ? x`<ex-icon
        icon=${this.isOpen ? "Up caret" : "Down caret"}
        label=${this.isOpen ? "Open" : "Close"}
        variant="tertiary"
        slot="suffix"
        class="combobox-arrow-icons"
        @click=${this.handleDrodownClick}
      ></ex-icon>` : E;
  }
  getUpdatedIndex(e) {
    const t = this.activeIndex, i = this.selectMenuItems.length - 1;
    switch (e) {
      case y.PREVIOUS:
        return Math.max(0, t - 1);
      case y.NEXT:
        return Math.min(i, t + 1);
      default:
        return t;
    }
  }
  renderAdditionalSearchIcon() {
    return this.searchIcon && this.loader ? x` <ex-loader
        color="dark"
        variant="component-level-medium"
        slot="prefix"
      ></ex-loader>` : this.searchIcon ? x`<ex-icon
        icon="Search"
        variant="icon"
        slot="prefix"
        label=${this.searchIconLabel}
      ></ex-icon>` : E;
  }
  render() {
    const e = this.disabled ? void 0 : "true", t = this.disabled ? void 0 : "true", i = this.disabled ? void 0 : this.removePill, o = D({ combobox: !0, [`combobox--size-${this.size}`]: !0, [`combobox--type-${this.type}`]: !0 }), n = this.select !== "single" && this.options.some((a) => a.selected);
    return x`<div class=${o}>
      <ex-input
        placeholder=${this.placeholder}
        help-text=${S(this.helpText)}
        info-text=${S(this.infoText)}
        error-msg=${S(this.errorMsg)}
        label=${S(this.label)}
        ?suppress-validity-check=${n}
        ?disabled=${this.disabled}
        ?readonly=${this.readonly}
        ?required=${this.required}
        ?invalid=${this.invalid}
        ?optional=${this.optional}
        tooltipText=${this.tooltipText}
        ?showStatusIcon=${this.showStatusIcon}
        footertype=${this.footerType}
        size=${this.searchSize}
        ?clearable=${!this.hideClearIcon}
        @onInput=${this.onInputHandler}
        @onFocus=${this.onInputFocusHandler}
        @onBlur=${this.onInputBlurHandler}
        @keydown=${this.handleKeyDown}
        @onClear=${this.clearPreviousSelectionForSingleSelect}
        input-id="withPrefix"
        class="input-combo"
        exportparts="input--container, input--typeahead, input--menu--show"
        value=${this.inputValue}
        autocomplete=${this.autoComplete}
        statusIconLabel=${this.statusIconLabel}
      >
        ${this.searchIcon} ${this.renderAdditionalSearchIcon()}
        ${this.comboboxAsyncDataTask.render({ complete: () => this.getMainMenu() })}
        ${this.getSuffix()}
      </ex-input>
      ${this.select === "default" ? x`<ex-pill-group
            .values=${this.selectedItems}
            @onClear=${this.clearAllSelections}
            @onRemove=${i}
            ?showClear=${this.showClear}
            ?selected=${e}
            ?interactive=${t}
            removable
            showAllPills
          >
          </ex-pill-group>` : ""}
    </div>`;
  }
}
r.styles = Y`
    ${Z(`:host .combobox--size-standard{max-width:calc(.4 * var(--exo-size-1) + var(--exo-size-5))}:host .combobox--size-large{max-width:var(--exo-size-6)}:host .combobox--size-medium{max-width:var(--exo-size-4)}:host .combobox--size-small{max-width:var(--exo-size-2)}:host ::part(menu-item){display:none}:host .combobox__menu.combobox__menu--fixed{position:fixed}:host .combobox__menu{max-height:var(--auto-size-available-height, none)}:host .combobox__pills{display:flex;flex-wrap:wrap;gap:var(--exo-spacing-2x-small)}:host .typeaheadmenu-hidden{display:none}:host ex-input::part(input--container):hover{border:var(--exo-spacing-4x-small) solid var(--exo-color-background-action-hover)!important}:host ex-input[invalid]::part(input--container){border:var(--exo-spacing-4x-small) solid var(--exo-color-border-danger-strong)!important}:host ex-input[disabled]::part(input--container){pointer-events:none}:host ex-input[invalid]::part(input--container):hover{border:var(--exo-spacing-4x-small) solid var(--exo-color-border-danger-strong)!important}:host ex-input::part(form-control-label){color:var(--exo-color-font)!important}:host ex-input::part(input--container):focus-within{border:var(--exo-spacing-4x-small) solid var(--exo-color-border-tertiary)!important;outline:var(--exo-spacing-4x-small) solid var(--exo-color-border-tertiary)}:host ex-input[invalid]::part(input--container):focus-within{border:var(--exo-spacing-4x-small) solid var(--exo-color-border-danger-strong)!important;outline:var(--exo-spacing-4x-small) solid var(--exo-color-border-danger-strong)}:host .combobox__pill{margin-top:var(--exo-spacing-2x-small)}:host ex-input::part(input__clear-btn){left:6px}.combobox-arrow-icons{display:inline-block;padding:var(--exo-spacing-2x-small);border-radius:var(--exo-spacing-3x-small);position:relative;left:6px}.combobox-arrow-icons[invalid]{background:var(--exo-color-background-action-strong-weak)}.combobox-arrow-icons[disabled]{color:var(--exo-color-background-disabled)}.combobox-arrow-icons:hover{color:var(--exo-color-background-deselected-hover);background:var(--exo-color-background-action-hover-weak)}
`)}
  `, l([H("ex-input")], r.prototype, "inputElement", 2), l([H(".input-combo")], r.prototype, "selectControl", 2), l([ie(".combobox__menu")], r.prototype, "comboboxMenu", 2), l([h()], r.prototype, "label", 2), l([h({ attribute: "help-text" })], r.prototype, "helpText", 2), l([h({ attribute: "info-text" })], r.prototype, "infoText", 2), l([h({ attribute: "error-msg" })], r.prototype, "errorMsg", 2), l([h()], r.prototype, "noResultText", 2), l([h()], r.prototype, "noOptionText", 2), l([h()], r.prototype, "placeholder", 2), l([h({ type: Boolean, reflect: !0 })], r.prototype, "disabled", 2), l([h({ type: Boolean, reflect: !0 })], r.prototype, "readonly", 2), l([h({ type: Boolean, reflect: !0 })], r.prototype, "required", 2), l([h({ type: Boolean })], r.prototype, "optional", 2), l([h({ type: Boolean })], r.prototype, "searchIcon", 2), l([h({ type: Boolean, reflect: !0 })], r.prototype, "invalid", 2), l([h({ type: Boolean, reflect: !0 })], r.prototype, "loader", 2), l([h({ reflect: !0 })], r.prototype, "value", 2), l([h()], r.prototype, "size", 2), l([h()], r.prototype, "type", 2), l([h()], r.prototype, "select", 2), l([h()], r.prototype, "searchSize", 2), l([h()], r.prototype, "tooltipText", 2), l([h()], r.prototype, "menuHeight", 2), l([h()], r.prototype, "footerType", 2), l([h({ type: Object })], r.prototype, "comboboxOptions", 2), l([h({ type: Object })], r.prototype, "defaultValues", 2), l([h({ type: Boolean, reflect: !0 })], r.prototype, "hideClearIcon", 2), l([I()], r.prototype, "options", 2), l([h()], r.prototype, "inputValue", 2), l([I()], r.prototype, "isOpen", 2), l([h({ type: Number, attribute: "supress-menu-width" })], r.prototype, "supressMenuWidth", 2), l([I()], r.prototype, "activeIndex", 2), l([I()], r.prototype, "unselectedItemsLength", 2), l([I()], r.prototype, "selectMenuItems", 2), l([I()], r.prototype, "selectedItems", 2), l([h({ reflect: !0 })], r.prototype, "strategy", 2), l([h({ type: Boolean, reflect: !0 })], r.prototype, "showStatusIcon", 2), l([h({ type: Boolean, reflect: !0 })], r.prototype, "selectAllMenuItem", 2), l([h({ type: String })], r.prototype, "autoComplete", 2), l([h({ type: Boolean, reflect: !0 })], r.prototype, "showClear", 2), l([h({ type: String })], r.prototype, "searchIconLabel", 2), l([h({ type: String })], r.prototype, "statusIconLabel", 2), l([h({ type: Array })], r.prototype, "selectedValues", 2);
const Ve = (s = "") => {
  te("ex-combobox", r, s), ce(s), pe(s), de(s), ue(s), me(s), be(s), ve(s), xe(s);
}, rt = se({ tagName: "ex-combobox", elementClass: r, react: J, events: { onChange: "on-change", onInput: "on-input", onSelectionChange: "on-selection-change", onClear: "clear", onRemove: "remove" }, displayName: "ExCombobox", registerWebComponent: Ve });
export {
  Pe as ComboboxSearchSize,
  Oe as ComboboxSelect,
  _e as ComboboxSize,
  Me as ComboboxType,
  rt as ExCombobox,
  Ve as register
};
